import PropTypes from 'prop-types'
import { createRef, PureComponent } from 'react'
import { connect } from 'react-redux'
import { Table } from 'semantic-ui-react'

import { navigateToMatch } from 'app'
import { naturalSort } from 'utils'

import Minute from './match/Minute'
import Score from './match/Score'
import Date from './round/Date'
import Avatar from './team/Avatar'
import Name from './team/Name'

import './MatchesTable.css'

const MAX_SCREEN_WIDTH_FOR_NICKNAMES = 560

class MatchesTable extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      containerWidth: 0,
    }

    this.el = createRef()
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  resize = () => this.setState({ containerWidth: Number(this.el.current?.offsetWidth) || 0 })

  render() {
    const { highlightedMatches, highlightedTeams, mobile, printable, round, teams, widget } = this.props
    const { containerWidth } = this.state

    const useNickNames = containerWidth <= MAX_SCREEN_WIDTH_FOR_NICKNAMES

    if (round.stage && round.stage.teams) {
      ;(round.matches || []).forEach((match, index) => {
        const localGroup = round.stage.teams.find((t) => t.team.id === match.local.id)
        const visitorGroup = round.stage.teams.find((t) => t.team.id === match.visitor.id)
        if (localGroup && visitorGroup && localGroup.group && localGroup.group === visitorGroup.group) {
          round.matches[index].group = localGroup.group
        }
      })
    }

    const groups = {}
    ;(round.matches || []).forEach((match) => {
      const group = match.group || ''
      const key = match.date ? match.date.format('YYYY-MM-DD') : '-'

      if (!groups[group]) {
        groups[group] = {}
      }
      if (!groups[group][key]) {
        groups[group][key] = []
      }
      groups[group][key].push(match)
    })

    const groupsNames = Object.keys(groups).sort(naturalSort)
    const rows = []
    groupsNames.forEach((groupName) => {
      if (groupsNames.length > 1) {
        rows.push(
          <Table.Row key={groupName} className="MatchesTable__row group">
            <Table.Cell className="MatchesTable__group" colSpan="6">
              <b>Grupo {groupName || 'sin definir'}</b>
            </Table.Cell>
          </Table.Row>,
        )
      }
      Object.keys(groups[groupName] || {}).forEach((key) => {
        const list = groups[groupName][key]

        rows.push(
          <Table.Row key={`${groupName}${key}`} className="MatchesTable__row date">
            <Date date={key} />
          </Table.Row>,
        )

        list.forEach((match) => {
          if (teams[match.local.id] && teams[match.visitor.id]) {
            const highlight =
              highlightedMatches.indexOf(match.id) >= 0 ||
              highlightedTeams.indexOf(match.local.id) >= 0 ||
              highlightedTeams.indexOf(match.visitor.id) >= 0
            rows.push(
              <Table.Row
                key={match.id}
                className={`MatchesTable__row ${highlight ? 'highlight' : ''} ${printable ? 'printable' : ''}`}
                onClick={printable ? null : () => navigateToMatch(match.id, widget)}
              >
                <Minute match={match} printable={printable} />
                {printable && (
                  <Table.Cell className="LocationName" textAlign="left" title={match.location}>
                    {match.location}
                  </Table.Cell>
                )}
                <Name
                  align="right"
                  asText
                  printable={printable}
                  team={teams[match.local.id]}
                  useNick={useNickNames}
                  widget={widget}
                />
                <Avatar
                  className="!border-l-0 border-r border-greyLight"
                  printable
                  team={teams[match.local.id]}
                  widget={widget}
                />
                <Score match={match} printable={printable} />
                <Avatar printable team={teams[match.visitor.id]} widget={widget} />
                <Name
                  align="left"
                  asText
                  printable={printable}
                  team={teams[match.visitor.id]}
                  useNick={useNickNames}
                  widget={widget}
                />
              </Table.Row>,
            )
          }
        })
      })
    })

    return (
      <div ref={this.el}>
        <Table basic celled className="MatchesTable" selectable={!printable && !mobile} size="small" unstackable>
          <Table.Body>{rows}</Table.Body>
        </Table>
      </div>
    )
  }
}

MatchesTable.propTypes = {
  highlightedMatches: PropTypes.array,
  highlightedTeams: PropTypes.array,
  mobile: PropTypes.bool,
  printable: PropTypes.bool,
  round: PropTypes.object.isRequired,
  teams: PropTypes.object.isRequired,
  widget: PropTypes.bool,
}

MatchesTable.defaultProps = {
  highlightedMatches: [],
  highlightedTeams: [],
  mobile: false,
  printable: false,
  widget: false,
}

export default connect(
  ({
    environment: {
      device: { mobile },
    },
  }) => ({
    mobile,
  }),
)(MatchesTable)
